/**
 * Creates a unique identifier for external users by combining firstName, lastName, and email.
 * Format: firstName-lastName-email
 */
export function getExternalUserUniqueId({
  firstName,
  lastName,
  email,
}: {
  firstName: string;
  lastName: string;
  email: string;
}): string {
  return `${firstName}-${lastName}-${email}`;
}
